import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import {buildUrl, HttpError} from './jsonHttpClient';

export class MultipartHttpClient implements HttpClient {
  constructor(
    private readonly baseUrl: string,
    private readonly getToken?: () => Promise<string | undefined>,
  ) {}

  async get<Response>(_path: string): Promise<Response> {
    throw Error('Not implemented');
  }

  async delete(_path: string): Promise<void> {
    throw Error('Not implemented');
  }

  async patch<Request, Response>(_path: string, _body: Partial<Request>): Promise<Response> {
    throw Error('Not implemented');
  }

  // @ts-expect-error
  async post<Request, Response>(path: string, body: Request): Promise<Response> {
    const headers: {[p: string]: string} = {};
    if (this.getToken) {
      headers.Authorization = `Bearer ${await this.getToken()}`;
    }
    const url = path.startsWith('http') ? path : buildUrl(this.baseUrl, path);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...headers,
      },
      body: body as FormData,
    });
    if (response.status >= 300 || !response.ok) {
      throw new HttpError(response.status, await response.text());
    }
    if (response.status === 201) {
      return await response.json();
    }
  }

  async put<Request, Response>(_path: string, _body: Request): Promise<Response> {
    throw Error('Not implemented');
  }
}
